import ContactFormData from "../../models/ContactFormData";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface ValidationResult {
  success: boolean;
  errors: string[];
}

export const validateContactForm = ({name, email, phone, message} : ContactFormData) : ValidationResult => {
  let validationErrors : string[] = [];
  
  if (name.trim().length === 0) {
    validationErrors.push("Name is required");
  }

  if (email.trim().length === 0 || !emailRegex.test(email)) {
    validationErrors.push("Valid email is required");
  }

  const normalizedPhone = phone.replace(/\D/g, '');
  if (!/^\d{10}$/.test(normalizedPhone)) {
      validationErrors.push("Valid phone number is required");
  }

  if (message.trim().length < 15) {
    validationErrors.push("Message is required and must have at least 15 characters");
  }

  return {
    success: validationErrors.length === 0,
    errors: validationErrors 
  };
}